import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { tabClasses, tabsClasses, Box, Tabs, Tab } from '@mui/material';
import { Icon } from '../Icon/Icon.js';
import { IconButton } from '../IconButton/IconButton.js';
import { theme } from '../../utils/themeProvider.js';
import '@mui/styles';
import '@mui/material/styles';
import 'uuid/v4';
var _excluded = ["children", "value", "index", "className", "sx"];

var _tabBarContainer;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var styles = {
  tabBarContainer: (_tabBarContainer = {
    width: '100%'
  }, _defineProperty(_tabBarContainer, "& .".concat(tabClasses['root']), {
    minWidth: '120px',
    paddingX: 1.5,
    paddingY: 0.75
  }), _defineProperty(_tabBarContainer, "& .".concat(tabsClasses['scrollButtons']), {
    display: 'inherit'
  }), _defineProperty(_tabBarContainer, '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)', {
    '& [class*="MuiTabs-scrollable"]': {
      overflowX: 'hidden'
    }
  }), _tabBarContainer),
  verticalTabBarContainer: _defineProperty({
    flexGrow: 1,
    display: 'flex',
    marginRight: 2
  }, "& .".concat(tabClasses['root']), {
    minWidth: '120px',
    paddingX: 1.5,
    paddingBottom: 0.75
  }),
  activeTab: _defineProperty({}, "& .".concat(tabsClasses['indicator']), {
    top: 0
  }),
  activeVerticalTab: _defineProperty({}, "&.".concat(tabClasses['root'], ".Mui-selected"), {
    borderLeft: 'none',
    borderRight: 'none'
  }),
  inactiveTab: {
    '&:hover': {
      background: theme.palette.grey[300]
    }
  },
  inactiveVerticalTab: {
    textAlign: 'right',
    '&:hover': {
      background: theme.palette.grey[300]
    }
  },
  secondaryActiveTab: _defineProperty({
    textTransform: 'none'
  }, "&.".concat(tabClasses['root'], ".Mui-selected"), {
    borderLeft: 'none',
    borderRight: 'none'
  }),
  secondaryInactiveTab: {
    textTransform: 'none',
    borderBottom: '1px solid',
    borderColor: 'grey.600',
    '&:hover': {
      background: theme.palette.grey[300]
    },
    '&:focusVisible': {
      background: theme.palette.grey[300]
    }
  },
  horizontalBorder: {
    borderBottom: '1px solid',
    borderColor: 'action.disabled'
  },
  verticalTabs: {
    borderRight: '1px solid',
    borderColor: 'grey.600',
    alignItems: 'flex-end'
  },
  tabPanel: {
    marginTop: 1
  },
  verticalTabPanel: {
    marginTop: 1,
    marginLeft: 1,
    maxWidth: '70%'
  },
  tabBarExtender: {
    width: '100%',
    borderBottom: '1px solid',
    borderColor: 'grey.600'
  },
  iconTab: _defineProperty({
    minHeight: 0,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    '& > *:first-child': {
      marginBottom: 0
    },
    display: 'flex',
    alignItems: 'center'
  }, "&.".concat(tabClasses['root']), {
    paddingTop: 1.125,
    paddingBottom: 0.75
  }),
  verticalIconTab: {
    '& > *:first-child': {
      marginBottom: 0.5
    }
  },
  icon: {
    marginRight: 1
  },
  dragOverBorder: {
    borderRight: '3px solid',
    borderColor: 'primary.main'
  }
};

var TabPanel = function TabPanel(props) {
  var children = props.children,
      value = props.value,
      index = props.index,
      className = props.className,
      sx = props.sx,
      other = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    role: "tabpanel",
    sx: sx,
    className: className
  }, other), value === index ? children : null);
};

var TabBarDivider = function TabBarDivider(props) {
  var tabBarDividerStyle = props.tabBarDividerStyle;
  return /*#__PURE__*/React.createElement(Box, {
    sx: tabBarDividerStyle,
    className: 'tabBarDivider'
  });
};

var TabBar = function TabBar(_ref) {
  var primaryTabs = _ref.primaryTabs,
      primaryTabPanels = _ref.primaryTabPanels,
      orientation = _ref.orientation,
      component = _ref.component,
      onChange = _ref.onChange,
      defaultValue = _ref.defaultValue,
      externalState = _ref.externalState,
      externalValue = _ref.externalValue,
      selectionFollowsFocus = _ref.selectionFollowsFocus,
      secondaryStyling = _ref.secondaryStyling,
      sx = _ref.sx,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'scrollable' : _ref$variant,
      onDragStart = _ref.onDragStart,
      onDragEnd = _ref.onDragEnd,
      onDrop = _ref.onDrop,
      inlineAction = _ref.inlineAction,
      inlineActionIcon = _ref.inlineActionIcon,
      inlineActionLabel = _ref.inlineActionLabel;
  var tabBarContainer = styles.tabBarContainer,
      verticalTabBarContainer = styles.verticalTabBarContainer,
      activeTab = styles.activeTab,
      activeVerticalTab = styles.activeVerticalTab,
      inactiveTab = styles.inactiveTab,
      inactiveVerticalTab = styles.inactiveVerticalTab,
      secondaryInactiveTab = styles.secondaryInactiveTab,
      secondaryActiveTab = styles.secondaryActiveTab,
      horizontalBorder = styles.horizontalBorder,
      tabPanel = styles.tabPanel,
      verticalTabPanel = styles.verticalTabPanel,
      verticalTabs = styles.verticalTabs,
      tabBarExtender = styles.tabBarExtender,
      iconTab = styles.iconTab,
      verticalIconTab = styles.verticalIconTab,
      icon = styles.icon,
      dragOverBorder = styles.dragOverBorder;

  var _React$useState = React.useState(defaultValue || 0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      value = _React$useState2[0],
      setValue = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      dragOverIndex = _React$useState4[0],
      setDragOverindex = _React$useState4[1];

  var handleChange = function handleChange(event, newValue) {
    setValue(newValue);
    onChange && onChange(event, newValue);
  };
  /* istanbul ignore next */


  var handleDragStart = function handleDragStart(event, id) {
    // Fires once at the start of a drag event
    onDragStart && onDragStart(event, id);
  };
  /* istanbul ignore next */


  var handleDragOver = function handleDragOver(event, tabIndex) {
    // fires every few milliseconds while a draggable element is over a valid drop target
    // Set to prevent default if this a valid drop target
    event.preventDefault();

    if (tabIndex === dragOverIndex) {
      return;
    } else {
      setDragOverindex(tabIndex);
    }
  };
  /* istanbul ignore next */


  var handleDragEnd = function handleDragEnd(event, id) {
    event.preventDefault();
    onDragEnd && onDragEnd(event, id);
    setDragOverindex(null);
  };
  /* istanbul ignore next */


  var handleDrop = function handleDrop(event, tabIndex) {
    event.preventDefault();
    event.stopPropagation();
    onDrop && onDrop(event, tabIndex);
  };

  var activeTabStyles = secondaryStyling ? secondaryActiveTab : activeTab;
  var inactiveTabStyles = secondaryStyling ? secondaryInactiveTab : _objectSpread(_objectSpread({}, horizontalBorder), inactiveTab);

  var activeOrInactive = function activeOrInactive(activeValue, tabIndex) {
    return activeValue === tabIndex ? activeTabStyles : inactiveTabStyles;
  };

  var verticalActiveOrInactive = function verticalActiveOrInactive(activeValue, tabIndex) {
    return activeValue === tabIndex ? activeVerticalTab : inactiveVerticalTab;
  };

  var InlineActionButton = function InlineActionButton(_ref2) {
    var inlineAction = _ref2.inlineAction,
        inlineActionIcon = _ref2.inlineActionIcon,
        inlineActionLabel = _ref2.inlineActionLabel;
    return /*#__PURE__*/React.createElement(IconButton, {
      icon: inlineActionIcon ? inlineActionIcon : 'Info',
      onClick: inlineAction,
      label: inlineActionLabel
    });
  };

  return /*#__PURE__*/React.createElement(Box, {
    sx: orientation === 'vertical' ? verticalTabBarContainer : tabBarContainer
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: externalState ? externalValue : value,
    onChange: externalState ? onChange : handleChange,
    textColor: "primary",
    orientation: orientation,
    sx: [orientation === 'vertical' ? verticalTabs : activeTabStyles, sx],
    component: component,
    "data-test": orientation === 'vertical' ? "VerticalTabBar" : "TabBar",
    selectionFollowsFocus: selectionFollowsFocus,
    variant: variant
  }, primaryTabs.map(function (primaryTab, tabIndex) {
    var tabName = orientation === 'vertical' ? "tab-vertical-".concat(tabIndex) : "tab-".concat(tabIndex);
    var activeValue = externalState ? externalValue : value;
    return /*#__PURE__*/React.createElement(Tab, {
      draggable: primaryTab.draggable,
      onDragStart: function onDragStart(event) {
        return handleDragStart(event, primaryTab.tabId || tabIndex);
      },
      onDragEnd: function onDragEnd(event) {
        return handleDragEnd(event, primaryTab.tabId || tabIndex);
      },
      onDragOver: function onDragOver(event) {
        return handleDragOver(event, tabIndex);
      },
      onDrop: function onDrop(event) {
        return handleDrop(event, tabIndex);
      },
      id: primaryTab.tabId,
      key: tabName,
      label: primaryTab.label,
      sx: [orientation === 'vertical' ? verticalActiveOrInactive(activeValue, tabIndex) : activeOrInactive(activeValue, tabIndex), primaryTab.icon ? iconTab : undefined, primaryTab.icon && orientation === 'vertical' ? verticalIconTab : undefined, dragOverIndex === tabIndex ? dragOverBorder : undefined],
      disabled: primaryTab.disabled,
      component: component,
      "data-test": tabName,
      icon: primaryTab.icon && /*#__PURE__*/React.createElement(Icon, {
        icon: primaryTab.icon,
        fontSize: "small",
        sx: icon,
        style: {
          color: primaryTab.iconColor
        }
      }),
      disableFocusRipple: true
    });
  }), orientation !== 'vertical' ? /*#__PURE__*/React.createElement(TabBarDivider, {
    tabBarDividerStyle: tabBarExtender
  }) : null, inlineAction && orientation != 'vertical' && /*#__PURE__*/React.createElement(InlineActionButton, {
    inlineAction: inlineAction,
    inlineActionIcon: inlineActionIcon,
    inlineActionLabel: inlineActionLabel
  })), primaryTabPanels.map(function (tabPanelDisplay, tabPanelIndex) {
    var tabPanelKey = tabPanelIndex;
    var tabPanelName = orientation === 'vertical' ? "tabpanel-vertical-".concat(tabPanelIndex) : "tabpanel-".concat(tabPanelIndex);
    return /*#__PURE__*/React.createElement(TabPanel, {
      value: externalState ? externalValue : value,
      index: tabPanelDisplay.index,
      key: tabPanelKey,
      "data-test": tabPanelName,
      sx: orientation === 'vertical' ? verticalTabPanel : tabPanel,
      className: 'tabNestedWrapper'
    }, tabPanelDisplay.contentItem);
  }));
};

TabBar.defaultProps = {
  variant: 'scrollable',
  externalState: false
};
TabBar.displayName = 'TabBar';
export { TabBar };